import { ChainCurrencyEnum } from '@/app/store/api/restApi';

export const CURRENCY_SYMBOLS = [
  { value: ChainCurrencyEnum.Rub, symbol: '₽' },
  { value: ChainCurrencyEnum.Usd, symbol: '$' },
  { value: ChainCurrencyEnum.Eur, symbol: '€' },
  { value: ChainCurrencyEnum.Azn, symbol: null },
  { value: ChainCurrencyEnum.Amd, symbol: '֏' },
  { value: ChainCurrencyEnum.Byn, symbol: null },
  { value: ChainCurrencyEnum.Kzt, symbol: '₸' },
  { value: ChainCurrencyEnum.Kgs, symbol: null },
  { value: ChainCurrencyEnum.Mdl, symbol: null },
  { value: ChainCurrencyEnum.Tjs, symbol: null },
  { value: ChainCurrencyEnum.Tmt, symbol: null },
  { value: ChainCurrencyEnum.Uzs, symbol: null },
  { value: ChainCurrencyEnum.Aed, symbol: 'د.إ' },
  { value: ChainCurrencyEnum.Cny, symbol: '¥' },
  { value: ChainCurrencyEnum.Gbp, symbol: '£' },
  { value: ChainCurrencyEnum.Jpy, symbol: '¥' },
  { value: ChainCurrencyEnum.Chf, symbol: null },
  { value: ChainCurrencyEnum.Try, symbol: '₺' },
] as const;
